import React from "react";
import { AddFilterBaseFunc, IFilterKeys, IFilters, IPlotData, RemoveFilterBaseFunc } from "models/core";
import { DashboardFilterKeys } from "models/mdt";
import {  ChartOrientation, ChartType, QoolDashChart } from "../core";

import { HHSLabel } from "config/appUrlConfig";


interface IProps {
	plotData: IPlotData;
	activeFilters: IFilters<IFilterKeys>;
	addFilterFn: AddFilterBaseFunc<typeof DashboardFilterKeys>;
    removeFilterFn: RemoveFilterBaseFunc<typeof DashboardFilterKeys>;
}

/**
 * HHS Of Residence Chart
 */
export function HHSOfResidenceChart(props: IProps) {

	return (
		<QoolDashChart
			xAxis={{ horizontalOrientation: { label: "Number of Diagnoses" }, verticalOrientation: { label: "" }}}
			yAxis={{ horizontalOrientation: { label: "" }, verticalOrientation: { label: "Number of Diagnoses" }}}
			chartOrder={{ horizontalOrientation: { reversed: false }, verticalOrientation: { reversed: true }}}
			defaultChartOrientation={ChartOrientation.Horizontal}
			defaultChartType={ChartType.Bar}
			chartTitle={`${HHSLabel} Of Residence`}
			filterKey={DashboardFilterKeys.HHSOfResidence.key}
			plotData={[props.plotData]}
			activeFilters={props.activeFilters}
			addFilterFn={props.addFilterFn}
			removeFilterFn={props.removeFilterFn}
			sortUnknownToEnd={true}
			hoverText="Diagnoses"
			chartIcons={{
				line: false,
			}}
		/>
	)
}
